export default __webpack_public_path__ + "static/gl-da5a7774a68a20241c32e666748f939a.svg";